import React, { useState } from "react";
import { useSelector } from "react-redux";
import api from "../../../utilis/api";
import { toast } from "react-toastify";
import { PasswordInput } from "../../Buttons";

const EditPassword = ({ userData, onSave }) => {
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const { token } = useSelector((state) => state.user);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswords({ ...passwords, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { currentPassword, newPassword, confirmPassword } = passwords;

    // 1️⃣ Validate new password and confirm password
    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match", {
        autoClose: 4000,
      });
      return;
    }

    try {
      // 2️⃣ Call backend API
      const res = await api.put(
        `auth/change-password/${userData._id}`,
        {
          oldPassword: currentPassword,
          newPassword: newPassword,
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.data?.meta?.success) {
        toast.success(
          res.data.meta.message || "Password updated successfully",
          {
            autoClose: 2000,
          },
        );
        setPasswords({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        onSave();
      } else {
        toast.error(res.data?.meta?.message || "Password update failed", {
          autoClose: 4000,
        });
      }
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message, { autoClose: 5000 });
    }
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <PasswordInput
        label="Current Password"
        name="currentPassword"
        value={passwords.currentPassword}
        onChange={handleChange}
      />

      <PasswordInput
        label="New Password"
        name="newPassword"
        value={passwords.newPassword}
        onChange={handleChange}
      />

      <PasswordInput
        label="Confirm New Password"
        name="confirmPassword"
        value={passwords.confirmPassword}
        onChange={handleChange}
      />

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="submit"
          className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all duration-300"
        >
          Change Password
        </button>
      </div>
    </form>
  );
};

export default EditPassword;
